import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";
import { consultCarreras, ConsultSemestres } from '../../funciones/MateriasFunction';

import AlumnosCarrera from './AlumnosCarrera';
import AlumnosSemestre from './AlumnosSemestre';

class DatosEstadisticos extends Component {
    state = {
        carrerasD: [],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Carreras</React.Fragment>,
        semestresD: [],
        preloaderS: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Semestres</React.Fragment>,
    }

    componentDidMount = () => {
        consultCarreras ((resp) => {
            this.setState({carrerasD: resp})
        })
        
        ConsultSemestres ((resp) => {
            this.setState({semestresD: resp})
        })
    }

    contenido = () => {
        const styles = {
            padding: 2, fontSize: 12
        }

        let carreras = () => {
            let  { preloader, carrerasD } = this.state;

            if (carrerasD.length === 0) return (
                <tr>
                    <td colSpan={2} align="center">{preloader}</td>
                </tr>
            )

            return (
                carrerasD.map(option => (
                    <AlumnosCarrera key = {option.value} datos = {option} />
                ))
            )
        }

        let semestres = () => {
            let  { preloaderS, semestresD } = this.state;

            if (semestresD.length === 0) return (
                <tr>
                    <td colSpan={2} align="center">{preloaderS}</td>
                </tr>
            )
            
            let time = 0;
            return (
                semestresD.map(option => {
                    time += 3000;
                    return(<AlumnosSemestre key = {option.value} datos = {option} time = {time}/>)
                })
            )
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">Alumnos por Carrera</div>
                <div className="table-responsive custom-mt-10">
                    <Table hover style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="40%" style={styles}><strong>Carrera</strong></td>
                                <td align="center" width="60%" style={styles}><strong>Estadsística</strong></td>
                            </tr>
                            {carreras()}
                        </tbody>
                    </Table>
                </div>
                <div className="custom-alert-info custom-mt-10">Alumnos por Semestre</div>
                <div className="custom-mt-10 text-danger" style={{fontSize: 11}}><strong>IMPORTANTE:</strong> Los totales reflejados en el siguiente recuadro pueden diferir del recuadro de <strong>Alumnos por Carrera</strong> debido a que hay estudiantes cursando diversos semestres a la vez</div>
                <div className="table-responsive custom-mt-10" style={{overflowX: "hidden", overflowY: "auto", maxHeight: "70vh"}}>
                    <Table hover style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="40%" style={styles}><strong>Semestre</strong></td>
                                <td align="center" width="60%" style={styles}><strong>Estadsística</strong></td>
                            </tr>
                            {semestres()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }
    
    ayuda = () => (
        <Row>
            <Col md = {12} align = "justify">
                En este módulo puedes ver la cantidad de estudiantes de la siguiente manera:
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                <div className="custom-alert-info">Alumnos por Carrera</div>
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                En esta seccion se encuentran los totales de alumnos inscritos por cada carrera
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="70"
                        aria-valuemin="0" aria-valuemax="100" style={{width: `70%`, backgroundColor:"#A0555C"}}>
                        70%
                    </div>
                </div>
                Esta barra representa el porcentaje de estudiantes <strong>femeninas</strong>
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow="70"
                        aria-valuemin="0" aria-valuemax="100" style={{width: `30%`, backgroundColor:"#1f2f6e"}}>
                        30%
                    </div>
                </div>
                Esta barra representa el porcentaje de estudiantes <strong>masculinos</strong>
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                <div className="custom-alert-info">Alumnos por Semestre</div>
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-10">
                En esta seccion se encuentran los totales de alumnos inscritos por cada semestre.
                <div className="custom-mt-20"><strong>IMPORTANTE: Los totales reflejados en el este recuadro pueden diferir del recuadro de Alumnos por Carrera debido a que hay estudiantes cursando diversos semestres a la vez</strong></div>
            </Col>
            <Col md = {12} align = "justify" className="custom-mt-20">
                Además de la barra de porcentaje y la cantidad de alumnos, en esta sección encuentrarpas un botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-book"></i> Ver Secciones</button> con el que podrás ver detalladamente la información de los estudiantes en cada sección
            </Col>
        </Row>
    )

    render() {

        return(
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div>
                            {this.contenido()}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Datos Estadísticos</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
 
export default DatosEstadisticos;


// WEBPACK FOOTER //
// ./src/views/Opciones/DatosEstadisticos.jsx